import { render, staticRenderFns } from "./PdpRexallRaddar.vue?vue&type=template&id=0950b1fd&scoped=true"
import script from "./PdpRexallRaddar.vue?vue&type=script&lang=js"
export * from "./PdpRexallRaddar.vue?vue&type=script&lang=js"
import style0 from "./PdpRexallRaddar.vue?vue&type=style&index=0&id=0950b1fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950b1fd",
  null
  
)

export default component.exports